module.exports = __webpack_public_path__ + "img/launch-new.8fa1b67b.png";